import React, {
  useEffect,
  useState,
} from 'react';
import {
  TextField, Button, CardContent, CardHeader, TextareaAutosize, Switch, Select, MenuItem, FormControl, InputLabel,
} from '@material-ui/core';
import {
  Props,
} from './types';
import { ColorPalette } from './types';


const DescriptionWidgetCard: React.FC<Props> = (props: Props) => {
  useEffect(() => {
    props.handleChangeData('textColor', props.focusedWidgetData.params.textColor || ColorPalette.ON_SURFACE)
  },[props.focusedWidgetData.widgetInstanceId])

  return (
    (
      <>
        <CardContent>
          <TextField
            value={props.focusedWidgetData.params.text || ''}
            onChange={(event) => props.handleChangeData('text', event.target.value)}
            autoFocus
            margin="dense"
            id="Description"
            label="Description"
            fullWidth
            multiline
            rows={2}
            rowsMax={4}
          />

          <FormControl fullWidth >
            <InputLabel>Description Color</InputLabel>
            <Select
              onChange={(event) => props.handleChangeData('textColor', event.target.value)}
              value={props.focusedWidgetData.params.textColor || ''}
            >
              {Object.values(ColorPalette).map((cp: string) => <MenuItem key={cp} value={cp}>{cp}</MenuItem>)}
            </Select>
          </FormControl>
        </CardContent>
      </>
    )
  );
};

export default DescriptionWidgetCard;

